import { useEffect } from 'react';
import { setPageTargeting } from './index';

type ContentTargeting = {
  playlist?: string;
  series?: string;
  talk?: string;
};

/**
 * Sets page-level targeting for different content types
 * Should be called once per page near the top of the component tree
 */
export function usePageTargeting(targeting: ContentTargeting): void {
  useEffect(() => {
    const pageTargeting: Record<string, string> = {};

    // Only add defined values to targeting
    if (targeting.playlist) pageTargeting.playlist = targeting.playlist;
    if (targeting.series) pageTargeting.series = targeting.series;
    if (targeting.talk) pageTargeting.talk = targeting.talk;

    // Only set targeting if we have values
    if (Object.keys(pageTargeting).length > 0) {
      setPageTargeting(pageTargeting);
    }
  }, [targeting.playlist, targeting.series, targeting.talk]);
}
